module.exports = __webpack_public_path__ + "static/media/fondo_gestion.1179edca.jpg";